import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2026-05-25 21:18:10 +0200 (Mon, 25 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163265 $
//  Purpose   : parts for vlm support
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
import { funcPart, loadLazy as ll } from 'uix/parts';
export const VlmVisualEditor = ll(()=>import(/* webpackChunkName: 'vlm' */ './visualedit'));
const _VlmCodeEditor = ll(()=>import(/* webpackChunkName: 'vlm' */ './plainedit'));
export const VlmCodeEditor = funcPart({
    partStyle: {
        overflowX: 'hidden'
    }
}, (props)=>/*#__PURE__*/ _jsx(_VlmCodeEditor, {
        ...props
    }));
export const VlmTextTickerEditor = ll(()=>import(/* webpackChunkName: 'vlm' */ './ttselect'));
export const VlmDescriptionEditor = ll(()=>import(/* webpackChunkName: 'vlm' */ './descriptionedit'));
export const VlmEngines = ll(()=>import(/* webpackChunkName: 'vlm' */ './engines'));
